module.exports = __webpack_public_path__ + "static/media/adm3.6b2c5964.jpg";